import { render, staticRenderFns } from "./OrderPagination.vue?vue&type=template&id=340ab1ce&"
import script from "./OrderPagination.vue?vue&type=script&lang=js&"
export * from "./OrderPagination.vue?vue&type=script&lang=js&"
import style0 from "./OrderPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports